const TYPE_DISPLAY = {
  Horizontal: 1,
  Vertical: 2,
  Both: 3,
};

export { TYPE_DISPLAY };
